import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const form: ThemeUICSSObject = {
  /* PREPEND HERE */

  flexDirection: 'column',

  '.fieldWrapper': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',

    '&.checkbox': {
      alignItems: 'start',
    },
  },
  '.error': {
    borderLeftStyle: 'solid',
    borderLeftWidth: '4px',
    borderLeftColor: 'danger',
  },
  '.touched': {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'touchedBorderColor',

    '&.radio-label': {
      border: 'none',

      'input[role]:checked~svg': {
        '&, path': {
          color: 'palette.primary.main',
        },
      },
    },
  },
};

export default form;
